import React, { useEffect, useState } from "react";
import { templatePropTypes } from "../constants";
import { Logo } from "../components/Logos/Logo";
import NewsText from "./NewsText";
import SmiJs from "../components/SmiJs";
import BackClick from "../components/smiWidgets/BackClick";
import Popup from "../components/smiWidgets/Popup";
import NewsPreview from "./NewsPreview";
import BlurReload from "../utils/blurReload";
import { SideBar } from "./adblocks/SideBar";
import { AdSlot } from "../components/ads/AdSlot";
import { resolveSlotSettings, resolveSlotValue, resolveSlotValues } from "../utils/adConfig";
import { Feed } from "./adblocks/Feed";
import { PopupModal } from "./adblocks/PopupModal";
import { AdfoxInvisible } from "../components/adfoxBlocks/InvisibleAdfox";
import SmiWidget from "../components/smiWidgets/SmiWidget";
import { widgetIds } from "./smiWidgets/widgetIds";
import AnalyticsTracker from "../components/AnalyticsTracker";

export default function Template2013Component({
    news,
    context,
    isFull,
    isDesktop,
    showPopUp,
    showBackClick,
    refreshTime,
    popUpType,
    showMainLogo,
    fprVersion,
    currentDomain,
}) {
    const [showModal, setShowModal] = useState(false);
    const widgetBlocks = widgetIds[fprVersion] || widgetIds["main"];
    // Липкость сайдбара: из БД, если кампания там заведена, иначе прежнее
    // безусловное поведение — сегодня этот сайдбар липкий всегда.
    const dbSidebar = resolveSlotSettings("sidebar", { isFull, isDesktop });
    const sidebarSticky = dbSidebar ? dbSidebar.isSticky : true;
    let sid = context.analytics_lable;

    useEffect(() => {
        const timer = setTimeout(() => {
            setShowModal(true);
        }, 5000);

        return () => clearTimeout(timer);
    }, []);

    const closeModal = () => {
        setShowModal(false);
    };

    return (
        <div id="wrapper">
            {showBackClick && (
                <BackClick
                    maxRedirectsCount={1}
                    block_id={resolveSlotValue("backclick", { isFull, isDesktop, fallback: widgetBlocks.backClick })}
                    domain={currentDomain}
                />
            )}
            {showPopUp && (
                <Popup
                    popUpType={popUpType}
                    adIds={resolveSlotValue("popup", { isFull, isDesktop, fallback: widgetBlocks.popup })}
                    domain={currentDomain}
                    isDesktop={isDesktop}
                />
            )}
            <BlurReload
                isDesktop={isDesktop}
                domain={currentDomain}
                refresh={"lp2013"}
                sid={sid}
                timeout={refreshTime}
            />
            <SmiJs context={context} />
            <AdSlot
                slot="fullscreen"
                isFull={isFull}
                isDesktop={isDesktop}
                fallback={<SmiWidget isFull={isFull} isDesktop={isDesktop} blockIds={widgetBlocks.fullScreen} />}
            />
            {isDesktop && (
                <PopupModal
                    show={showModal}
                    onClose={closeModal}
                    isFull={isFull}
                    isDesktop={isDesktop}
                    widgetBlocks={widgetBlocks}
                />
            )}
            <div className="wrapper-holder">
                <header id="header" className="flex">
                    <strong className="logo">
                        <a href="#">
                            <Logo isDark={true} showMainLogo={showMainLogo} />
                        </a>
                    </strong>
                </header>
                <main id="main">
                    <AdSlot
                        slot="push"
                        isFull={isFull}
                        isDesktop={isDesktop}
                        fallback={<SmiWidget isFull={isFull} isDesktop={isDesktop} blockIds={widgetBlocks.push} />}
                    />
                    <AdSlot
                        slot="topad"
                        isFull={isFull}
                        isDesktop={isDesktop}
                        fallback={<SmiWidget isFull={isFull} isDesktop={isDesktop} blockIds={widgetBlocks.toPad} />}
                    />
                    <div className="main-holder flex">
                        <section id="content">
                            {isFull ? (
                                <NewsText
                                    news={news}
                                    context={context}
                                    isFull={isFull}
                                    isDesktop={isDesktop}
                                    widgetBlocks={widgetBlocks}
                                />
                            ) : (
                                <NewsPreview image={news.image} title={news.title} isDesktop={isDesktop} />
                            )}
                        </section>
                        {isDesktop && (
                            <SideBar
                                isDesktop={isDesktop}
                                isFull={isFull}
                                widgetBlocks={resolveSlotValues("sidebar", {
                                    isFull,
                                    isDesktop,
                                    fallback: widgetBlocks.sideBar,
                                })}
                                isSticky={sidebarSticky}
                            />
                        )}
                    </div>
                    <AdSlot
                        slot="feed"
                        isFull={isFull}
                        isDesktop={isDesktop}
                        fallback={<Feed isDesktop={isDesktop} isFull={isFull} widgetBlocks={widgetBlocks.feed} />}
                    />
                    <AdfoxInvisible isTop={true} />
                    <AdfoxInvisible isTop={false} />
                    <footer className="down" />
                </main>
            </div>
            <AdSlot
                slot="floorad"
                isFull={isFull}
                isDesktop={isDesktop}
                fallback={<SmiWidget isFull={isFull} isDesktop={isDesktop} blockIds={widgetBlocks.floorAd} />}
            />
            <AnalyticsTracker
                newsId={news.id}
                streamId={context.stream_id}
                isFull={isFull}
                sessionId={context.session_id}
                visitorId={context.visitor_id}
                utmParams={context.utm_params}
                device={context.device}
                browser={context.browser}
            />
        </div>
    );
}

Template2013Component.propTypes = templatePropTypes;
